import React, { useState } from "react";
import styled from "styled-components";
import { CaretDown } from "phosphor-react";
import { ClickAwayListener } from "@mui/material";
import Checkbox from "../Controls/Checkbox";
import ScrollEffect from "../../effects/ScrollEffect";
import colors from "../../utils/constants/COLORS";

export default function ConditionSelect({
  handleChange,
  isIncludeInactive,
  setIsIncludeInactive,
  isIncludeElapsed,
  setIsIncludeElapsed,
  options,
  defaultValue,
  value,
  prefix,
  label,
  id,
  title,
}) {
  const [showOptions, setShowOptions] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setShowOptions(false)}>
      <SelectStyle onClick={() => setShowOptions((prev) => !prev)}>
        <LabelStyle value={value} htmlFor={id} title={title}>
          {label}
        </LabelStyle>
        {prefix} <Placeholder>{value || defaultValue || "Select"}</Placeholder>{" "}
        <CaretDown weight="thin" size={14} />
        {showOptions && (
          <OptionsStyle>
            <DefaultValue>{defaultValue}</DefaultValue>
            {/* <OptionStyle>
              <Checkbox
                label="Include inactive"
                checked={isIncludeInactive}
                onChange={() => {
                  setIsIncludeInactive(!isIncludeInactive);
                }}
              />
            </OptionStyle> */}
            <OptionStyle>
              <Checkbox
                label="Include elapsed end date"
                checked={isIncludeElapsed}
                onChange={() => {
                  setIsIncludeElapsed(!isIncludeElapsed);
                }}
              />
            </OptionStyle>
            <ScrollEffect height="200px">
              {options?.map((option, index) => (
                <OptionStyle
                  key={index}
                  onClick={() => {
                    handleChange(option);
                  }}
                  selected={option === value}
                >
                  {option}
                </OptionStyle>
              ))}
            </ScrollEffect>
          </OptionsStyle>
        )}
      </SelectStyle>
    </ClickAwayListener>
  );
}

const SelectStyle = styled.div`
  position: relative;
  cursor: pointer;
  border: 1px solid lightgray;
  padding: 5px 15px;
  border-radius: 4px;
  max-width: 220px;
  min-width: fit-content;
  width: 100%;
  height: 33.2px;
  font-size: smaller;
  color: gray;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const OptionsStyle = styled.div`
  display: grid;
  gap: 5px;
  position: absolute;
  top: 120%;
  left: 0;
  background-color: #fff;
  box-shadow: 1px 6px 12px grey;
  padding-top: 8px;
  border: 1px solid lightgray;
  border-radius: 4px !important;
  overflow: hidden;
  width: max-content;
  z-index: 100;
`;

const OptionStyle = styled.span`
  display: inline-block;
  padding: 8px 5px;
  background-color: ${(props) => (props.selected ? "#008060" : "#fff")};
  color: ${(props) => (props.selected ? "#fff" : "#008060")};
  border-bottom: ${(props) =>
    props.selected ? "1px solid #fff" : "1px solid lightgrey"};

  &&:hover {
    background-color: ${(props) => (props.selected ? "#016b50" : "aliceblue")};
  }
  &&:last-child {
    border-bottom: none;
  }
`;

const DefaultValue = styled.span`
  padding: 0 5px;
  color: ${colors.default.color};
  font-style: italic;

  &&:hover {
    background-color: unset;
  }
`;

const LabelStyle = styled.label`
  position: absolute;
  transition: 100ms ease-in-out;
  color: gray;
  cursor: text;
  user-select: none;
  white-space: nowrap;
  display: flex;
  align-items: center;

  font-size: x-small;
  top: -10px;
  background-color: #fff;
  padding: 2px 5px;
  left: 10px;
`;

const Placeholder = styled.span`
  text-transform: capitalize;
  color: ${colors.default.color};
`;
